import { render, staticRenderFns } from "./Webrtc.vue?vue&type=template&id=31405884&scoped=true&"
import script from "./Webrtc.vue?vue&type=script&lang=js&"
export * from "./Webrtc.vue?vue&type=script&lang=js&"
import style0 from "./Webrtc.vue?vue&type=style&index=0&id=31405884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31405884",
  null
  
)

export default component.exports